<template>
  <div>
    <v-app-bar
      :style="{
        // color: setting.BACKGROUNDCOLOR,
        backgroundColor: setting.COLOR,
      }"
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      dark
      ><HomeLogo class="mx-2"
        :objSetting="{ width: 40, height: 40, color: '#ffffff' }"
      ></HomeLogo>
      <v-toolbar-title class="text-h4 text--white">
        <strong
          :style="{
            color: setting.BACKGROUNDCOLOR,
          }"
          >C</strong
        >linical
        <strong
          :style="{
            color: setting.BACKGROUNDCOLOR,
          }"
          >T</strong
        >rial
        <strong
          :style="{
            color: setting.BACKGROUNDCOLOR,
          }"
          >B</strong
        >ox
      </v-toolbar-title>
      <v-app-bar-nav-icon @click.stop="navTriggle"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>

      <v-btn icon>
        <v-icon>mdi-heart</v-icon>
      </v-btn>

      <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>

      <v-menu>
        <template v-slot:activator="{ props }">
          <v-btn icon v-bind="props">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-for="n in 5" :key="n" @click="() => {}">
            <v-list-item-title>Option {{ n }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>
<script>
import { mapState } from "vuex";
import HomeLogo from "./HomeLogo";
export default {
  name: "AppBar",
  data: () => ({}),
  components: {
    HomeLogo,
  },
  mounted() {
    // bus.$on("RDSHOWBAR", (data) => {
    //   // console.log(data);
    //   this.drawer = data;
    // });
  },
  methods: {
    navTriggle() {
      // console.log(this.drawer);
      this.$store.commit("updateDrawer");
    },
  },
  computed: mapState({
    drawer: "drawer",
    setting: "setting",
  }),
};
</script>
